/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC } from 'react'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail'
import PhoneIcon from '@material-ui/icons/Phone'
import MaterialLink from '@material-ui/core/Link'

import { useProfileDetailsStyles } from './profile-details.styles'
import { components } from '@plandi/common/src/generated'
import { TranslationDictionary } from '@plandi/common'

type ProfileContactsUserProps = {
  user?: components['schemas']['UserResource']
  translate?: TranslationDictionary['data']
}

export const ProfileContactsUser: FC<ProfileContactsUserProps> = ({
  translate,
  user
}) => {
  const classes = useProfileDetailsStyles()

  const renderContact = () => {
    return (
      <>
        <Typography
          variant="subtitle1"
          color="primary"
          className={classes.title}
        >
          {translate?.shop['contact-details']}
        </Typography>
        {user?.phone && (
          <div className={classes.textWrap}>
            <PhoneIcon fontSize="small" className={classes.icon} />
            <Typography
              className={classes.text}
              variant="body2"
              component={MaterialLink}
              color="textPrimary"
              href={`tel: ${user?.phone}`}
            >
              {user?.phone}
            </Typography>
          </div>
        )}
        {user?.email && (
          <div className={classes.textWrap}>
            <AlternateEmailIcon fontSize="small" className={classes.icon} />
            <Typography
              className={classes.text}
              variant="body2"
              component={MaterialLink}
              color="textPrimary"
              href={`mailto: ${user?.email}`}
            >
              {user?.email}
            </Typography>
          </div>
        )}
      </>
    )
  }

  return (
    <Card className={classes.card}>
      <CardContent>{renderContact()}</CardContent>
    </Card>
  )
}
